import { render, staticRenderFns } from "./CampagnaModal.vue?vue&type=template&id=1fafd129"
import script from "./CampagnaModal.vue?vue&type=script&lang=js"
export * from "./CampagnaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports